import Sellers from "./pages/Sellers";
import ImportarAssinatura from "./pages/ImportarAssinatura";
import { Login } from "./pages/Login";
import Seller from "./pages/Sellers/Seller";
import Transfer from "./pages/Saldo";
import { PrivateRoute } from "./PrivateRouter";
import ResetPassword from "./pages/RedefinirSenha";
import ResetPasswordDetails from "./pages/RedefinirSenha/id";
import Invoices from "./pages/Invoices";
import { Box, Grid } from "@chakra-ui/react";
import { SideBar } from "./components/Sidebar";
import { Route, Routes, useLocation } from "react-router-dom";
import Repasses from "./pages/Repasses";
import { HistoryTransfer } from "./pages/History";
import { Contestacao } from "./pages/Contestacao";
import { FeatureToggles } from "./pages/FeatureToggles";
import { TaxesProvider } from "./contexts/TaxV2Context";
import { NewSeller } from "./pages/Sellers/NewSeller";
import { Navbar } from "./components/Navbar";
const user = JSON.parse(localStorage.getItem("barte-user-info"));
const isBarteAdmin = user?.roles?.includes("BARTE_ADMIN");

export const RoutesList = [
  {
    path: "/login",
    exact: true,
    isShowMenu: false,
    element: <Login />
  },
  {
    path: "/redefinir-senha",
    exact: true,
    isShowMenu: false,
    element: <ResetPassword />,
  },
  {
    path: "/redefinir-senha/:id",
    exact: true,
    isShowMenu: false,
    element: <ResetPasswordDetails />,
  },
  {
    path: "/",
    exact: true,
    isShowMenu: false,
    breadcrumb: "Vendedores",
    element:
      <PrivateRoute>
        <Sellers />
      </PrivateRoute>
  },
  {
    path: "/seller",
    title: "Vendedores",
    breadcrumb: "Vendedores",
    exact: true,
    isShowMenu: true,
    element:

      <PrivateRoute>
        <Sellers />
      </PrivateRoute>

  },
  {
    path: "/seller/:id",
    breadcrumb: "Editar",
    exact: true,
    isShowMenu: false,
    element:
      <PrivateRoute>
        <TaxesProvider>
          <Seller />
        </TaxesProvider>
      </PrivateRoute>
  },
  {
    path: "/seller/new",
    breadcrumb: "Novo Vendedor",
    exact: true,
    isShowMenu: false,
    element:
      <PrivateRoute>
        <NewSeller />
      </PrivateRoute>
  },
  {
    path: "/seller/:id/importar-assinaturas",
    breadcrumb: "Importar assinatura",
    exact: true,
    isShowMenu: false,
    element:
      <PrivateRoute>
        <ImportarAssinatura />
      </PrivateRoute>
  },
  {
    path: "/financeiro",
    title: "Financeiro",
    breadcrumb: "Financeiro",
    exact: true,
    isShowMenu: true,
    defaultIsOpen: false,
    isAccordion: true,
    items: [
      {
        path: "/saldo",
        title: "Saldo",
        breadcrumb: "Saldo",
        exact: true,
        isShowMenu: true,
        element:
          <PrivateRoute>
            <Transfer />
          </PrivateRoute>,
      },
      {
        path: "/transfer",
        title: "Repasses",
        breadcrumb: "Repasses",
        exact: true,
        isShowMenu: true,
        element:
          <PrivateRoute>
            <Repasses />
          </PrivateRoute>,
      },
      {
        path: "/history-transfer",
        title: "Histórico de movimentações",
        breadcrumb: "Histórico de movimentações",
        exact: true,
        isShowMenu: true,
        element:
          <PrivateRoute>
            <HistoryTransfer />
          </PrivateRoute>,
      },
    ]
  },
  {
    path: "/invoices",
    title: "Notas Fiscais",
    breadcrumb: "Notas Fiscais",
    exact: true,
    isShowMenu: true,
    element:
      <PrivateRoute>
        <Invoices />
      </PrivateRoute>
  },
  {
    path: "/contestation",
    title: "Contestação",
    breadcrumb: "Contestação",
    exact: true,
    isShowMenu: true,
    element:
      <PrivateRoute>
        <Contestacao />
      </PrivateRoute>
  },
  {
    path: "/feature-toggles",
    title: "Feature Toggles",
    breadcrumb: "Feature Toggles",
    exact: true,
    isShowMenu: isBarteAdmin,
    onlyBarte: true,
    element:
      <PrivateRoute>
        <FeatureToggles />
      </PrivateRoute>
  },
]

export function flatRoutesList() {


  const filterItems = (routes) =>
    routes
      .map(route => {
        if (route.items) {
          const filteredItems = route.items.filter(sub =>
            !sub.onlyBarte || isBarteAdmin
          );
          return filteredItems.length ? { ...route, items: filteredItems } : null;
        }
        return route.onlyBarte && !isBarteAdmin ? null : route;
      })
      .filter(Boolean);

  const topLevel = filterItems(RoutesList);
  const children = topLevel
    .filter(item => item.items)
    .map(item => item.items)
    .flat();

  return [...topLevel, ...children];
}

export function RoutesComponent() {
  const location = useLocation();
  const flatList = flatRoutesList();
  const routeComponents = flatList.map(({ path, element }, key) => (
    <Route path={path} element={element} key={key} />
  ));
  const hideLayout = location.pathname.includes("/login") || location.pathname.includes("/redefinir-senha");

  return (
    <Grid
      flexDir="row"
      gridTemplateAreas={`"S N" "S B" "S B"`}
      templateColumns={!hideLayout ? "auto 1fr" : "1fr"}
      gridTemplateRows="52px 1fr"
      h="100vh"
      w="100vw"
    >
      {!hideLayout ? (
        <>
          <Box gridArea={"N"} bgColor="gray.10">
            <Navbar />
          </Box>
          <Box gridArea={"S"} bgColor="gray.24" zIndex={1}>
            <SideBar />
          </Box>
          <Box
            gridArea={"B"}
            h="100%"
            bgColor="gray.10"
            p="20px 20px 80px"
          >
            <Routes>{routeComponents}</Routes>
          </Box>
        </>
      ) : (
        <Box>
          <Routes>{routeComponents}</Routes>
        </Box>
      )}
    </Grid>
  );
}